import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { RoleBasedAccessGuard } from './auth/role-based-access.guard';
import { VibeRouteGuard } from './auth/vibe-route.guard';
import { HomeComponent } from './pages/home/home.component';
import { MainLayoutComponent } from './pages/home/main-layout/main-layout.component';
import { AppGlobalService } from './services/app.global.service';
import appRoutesConfig from '../assets/configData/app-routes.json';

const MODULE_MAP: Record<string, () => Promise<any>> = {
  gathering: () => import('./pages/gathering/gathering.module').then((m) => m.GatheringModule),
  designs: () => import('./pages/designs/design.module').then((m) => m.DesignModule),
  prototyping: () => import('./pages/prototyping/prototyping.module').then((m) => m.PrototypingModule),
  technicaldesign: () =>
    import('./pages/technology-design/technology-design.module').then((m) => m.TechnologyDesignModule),
  settings: () => import('./pages/settings/settings.module').then((m) => m.SettingsModule),
  dashboards: () => import('./pages/dashboards/dashboards.module').then((m) => m.DashboardsModule),
  'app-dashboards': () => import('./pages/app-dashboards/app-dashboards.module').then((m) => m.AppDashboardsModule),
  discover: () => import('./pages/engineering/engineering.module').then((m) => m.EngineeringModule),
  blueprint: () => import('./pages/blueprint/blueprint.module').then((m) => m.BlueprintModule),
  code: () => import('./pages/code/code.module').then((m) => m.CodeModule),
  operate: () => import('./pages/operate/operate.module').then((m) => m.OperateModule)
};

const dynamicRoutes: Routes = appRoutesConfig.map((route: any) => ({
  path: route.path,
  loadChildren: MODULE_MAP[route.path]
}));

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'home/:orgId/:appId',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, RoleBasedAccessGuard],
    canActivateChild: [VibeRouteGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        children: [
          {
            path: '',
            redirectTo: () => {
              // since cannot decide whether it is beta-access(user, app) or not, DEFAULT to data-model screen, which is common for both
              return 'blueprint/project-charter';
            },
            pathMatch: 'full'
          },
          {
            path: 'build/overview',
            loadComponent: () =>
              import('./components/artifacts-overview/artifacts-overview.component').then(
                (m) => m.ArtifactsOverviewComponent
              )
          },
          {
            path: 'artifacts/overview',
            redirectTo: 'build/overview',
            pathMatch: 'full'
          },
          ...dynamicRoutes
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
